/**
    * created by yxxyyxyx
*
*/
    import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Row, Input, Tabs} from 'antd';
import TableComponents from "../../components/TableComponents";
import BaseComponent from "../../../../base/BaseComponent";
import {TitleIcon} from "../../../components/customTable/CustomTable";
import Btn from "../../components/btn/Btn";
import {formatDate} from '../../../../utils'
import request from "../../../../base/request";
import {setInfoToLocalStorage} from "../../../../actions";

const { TabPane } = Tabs;
const {Search} = Input;
export default class clueView extends BaseComponent {
    static defaultProps = {};
    static propTypes = {
    };

    constructor(props) {
        super(props);
        this.state = {
            activeKey:"全部",
            record:{},
            searchText:'',
            dataSource:[],
            start:1,
            size:10,
            count:0
        }
    }

    componentWillMount() {
    }
    sysConfigLoadOver() {
         this.getList()
        let account = window.top.currentUser.account;
        console.log(account)

    }
    componentDidMount() {
    }

    customRender() {
        return (
            <div style={{padding:'0 20px'}}>
                {this.renderTabList()}
                {this.renderBtnList()}
                {this.renderData()}

            </div>
        )
    }
    renderBtnList(){
        let addBtn = this.sysConfig.addBtn||[];
        let searchObj  = this.sysConfig.searchObj||{};
         return(
             <div style={{padding:'10px 0px',display:'flex',justifyContent:" space-between"}}>
                 <div>  <Btn btnList={addBtn} currentState={this.state} record={this.state.record}
                             refresh={() => this.refresh()}/></div>
               <div>
                   {searchObj&&searchObj.expression?<Search placeholder={searchObj.placeholder}  value={this.state.searchText}
                                      onChange={(e) => {
                                          this.setState({searchText: e.target.value})
                                      }} onSearch={(v) => this.onSearch(v)}
                                      style={{width: "200px"}}/>:''}
               </div>


             </div>
         )

    }
    //顶部搜索
    onSearch(v) {
        this.setState({searchText:v,start:1},()=>{
            this.getList()
        });
    }
    //选人数据
    renderData(){
        let TableList,statusColor
        let roleCodes=window.top.currentUser.roleCodes;
        let role= "txy";
        let columns;
        if(roleCodes.indexOf(role)>-1) {
            columns = this.sysConfig.columns1||[];
            statusColor = this.sysConfig.statusColor1||{};
        }else{
            columns = this.sysConfig.columns2||[];
            statusColor = this.sysConfig.statusColor2||{};
        }

        let data =this.state.dataSource;
        let btnList = this.sysConfig.btnList||[];
        let newColumns=[];

        columns&&columns.length&&columns.forEach((item,index)=>{
            if(item.key==="btnList"){
                newColumns.push({
                    title: item.title,
                    //dataIndex: item.key,
                    key: item.key,
                    render: (text, record, index) => {
                        return (<div>
                                <Btn btnList={btnList} currentState={this.state} record={record}
                                     refresh={() => this.refresh()}/>
                            </div>

                        )
                    }
                })
            }else if(item.key==='submitDate' ||item.key ==='createTime'){
                newColumns.push({
                    title: item.title,
                    dataIndex: item.key,
                    key: item.key,
                    render: (text, record, index) => {
                        return (
                            <div>{formatDate(text)}</div>
                        )


                    }
                })
            }else if(item.key==="status"){
                newColumns.push({
                    title: item.title,
                    key: item.key,
                    dataIndex: item.key,
                    render: (text, record, index) => {
                        let color,name ;
                        statusColor&&statusColor.forEach((item)=>{
                            if(item.status === text){
                                color = item.color
                                name =item.statusName
                            }
                        });
                        return (
                            <div><span style={{width:'8px',height:'8px',borderRadius:'50%',background:color,display: "inline-block",marginRight:'8px'}}></span><span>{name}</span></div>
                        )
                    }
                })
            }else if(item.key==="departObj"){
                newColumns.push({
                    title: item.title,
                    key: item.key,
                    dataIndex: item.key,
                    render: (text, record, index) => {
                        return (
                            <div>姚小妍</div>
                        )
                    }
                })
            }else{
                newColumns.push(item)
            }
        })
        return(
            <div>
                {this.sysConfig&&<TableComponents btnList={btnList}
                                                  dataSource={data}
                                                  columns={newColumns}
                                                  selections={false}
                                                  start={this.state.start}
                                                  size={this.state.size}
                                                  count={this.state.count}
                                                  onChange={(page, pageSize)=>{
                                                     this.state.start = page
                                                      this.state.size =pageSize
                                                      this.setState({},()=>{
                                                          this.getList()
                                                      })
                                                  }}
                                                 ></TableComponents>}
            </div>

        )
    }
    refresh() {
        this.getList()
    }
   //tabList 的渲染
    renderTabList(){
        let TableList;
        let roleCodes=window.top.currentUser.roleCodes;
        let role= "txy";
        if(roleCodes.indexOf(role)>-1) {
            TableList = this.sysConfig.TableList1||[];
        }else{
            TableList = this.sysConfig.TableList2||[];
        }
        console.log(TableList)
        return(
            <Tabs activeKey={this.state.activeKey}  onChange={this.changeTable}>
                {
                    TableList&&TableList.length&&TableList.map((item,index)=>{
                        return(<TabPane tab={item.title} key={item.key}></TabPane>
                        )})}

            </Tabs>
        )

    }
    changeTable=(key)=>{
        console.log(key)
      this.setState({activeKey:key,start:1},()=>{
          this.getList()
      })

    };

    getList() {
        let body = {};
        let params = [];

        let requestInformation = this.sysConfig.requestInformation || "";
        let listUrl = requestInformation.listUrl  || "";
        let requestMethod = requestInformation.requestMethod  || "post";
        let storyTypeKey = requestInformation.requestShowRefKey  || "showRef";
        let storyTypeVal = requestInformation.requestShowRefVal  ;

        let smallTabParam = requestInformation.smallTabParam ;
        smallTabParam.val = parseInt(this.state.activeKey);

        params.push(smallTabParam)


        let requestStartParam = requestInformation.requestStartParam  || "num";
        let requestSizeParam = requestInformation.requestSizeParam  || "size";


        body[requestStartParam] = this.state.start;
        body[requestSizeParam] = this.state.size;
        if(this.state.activeKey!=='全部'){
            body.params = params;
        }
        body[storyTypeKey] = storyTypeVal;
        request({url:listUrl, contentType:"json", body,  method:requestMethod, callBack:(data)=>{
              this.setState({dataSource:data.list,count:data.count})
            }});



    }


}
